import Price from './Price';


export default Price;
